// extracted by mini-css-extract-plugin
module.exports = {"modal":"PrintLabelModal_modal__2I_uu","buttons":"PrintLabelModal_buttons__1E1eu","primary":"PrintLabelModal_primary__3YwJd"};